import { X } from "lucide-react";
import { useId } from "react";
import { useTranslation } from "react-i18next";

import { ConditionText } from "./ConditionText";

import { Badge } from "@/components/ui/v2/badge";
import { Button } from "@/components/ui/v2/button";
import type { ConditionBadgeParts } from "@/features/segments/types";

type LegacyConditionChipProps = {
  conditionKey: string;
  parts: ConditionBadgeParts;
  readOnly: boolean;
  onRemove: () => void;
};

export function LegacyConditionChip({
  conditionKey,
  parts,
  readOnly,
  onRemove,
}: LegacyConditionChipProps) {
  const { t } = useTranslation();
  const textId = useId();
  const removeId = useId();

  return (
    <Badge
      variant="outline"
      size="large"
      layout="wrap"
      data-testid="legacy-condition"
      className="shrink flex-wrap gap-2"
    >
      <span className="min-w-40 flex-1">
        <ConditionText parts={parts} id={textId} />
      </span>
      <Badge variant="warning" size="small" className="shrink-0 px-2">
        {t("admin.segments.builder.legacy")}
      </Badge>
      {!readOnly && (
        <Button
          id={removeId}
          data-condition-key={conditionKey}
          type="button"
          variant="ghost-destructive"
          size="icon-sm"
          aria-label={t("common.removeCondition")}
          aria-labelledby={`${removeId} ${textId}`}
          onClick={onRemove}
        >
          <X aria-hidden />
        </Button>
      )}
    </Badge>
  );
}
